import React, { useState } from 'react'
import FieldInput from './components/input.tsx'
import FieldPop from './components/pop.tsx'
import { IField } from '../../../types'
import { EMPTY } from '../../../constants.jsx'
import { PERCENTAGE, DEFAULT_NUMBER } from '../../../constants.jsx'

const Field: React.FC<IField> = ({fieldText, icon, info, value, placeholder, inputHandler, fieldName, fieldType, currency, max, min, errorMessage}) => {

  const [isInfoEnabled, setIsInfoEnabled] = useState(false)

  const infoHandler = () => setIsInfoEnabled(!isInfoEnabled)

  const modified = (extra, value) => {
    if(!value) return ""
    if(!extra || extra === PERCENTAGE) return value

    return `${extra}${value}`
  }

  const ifMaxorMinValid = (min?.length && max?.length && parseInt(max) > 0 && parseInt(value) > 0) ? (parseInt(value) <= parseInt(max) && parseInt(value) >= parseInt(min)) : true
console.log(ifMaxorMinValid);

  return (
    <div className="calculator__field">
      <div className="calculator__field__inner">
        <div className='calculator__field__info'>
          <div className='calculator__field__info__content'>
            <FieldPop 
              text={info}
              isEnabled={isInfoEnabled}
            />
            <img onMouseEnter={infoHandler} onMouseLeave={infoHandler} src={icon} alt={fieldText} />
          </div>
        </div>
        <div className='calculator__field__group'>
          <div className='calculator__field__name'>
            <span>
              { fieldText }
            </span>
          </div>
          <div className='calculator__field__input'>
            <FieldInput 
              name={fieldName}
              type={fieldType}
              inputHandler={inputHandler}
              value={modified(currency, value)}
              placeholder={modified(currency, DEFAULT_NUMBER)}
              min={min || DEFAULT_NUMBER}
              max={max || EMPTY}
            />
            { currency === PERCENTAGE &&
              <span className='currency'>{currency}</span>
            }
          </div>
        </div>
      </div>
      {!ifMaxorMinValid &&
        <div className="calculator__field__error"><em>{errorMessage}</em></div>
      }
    </div>
  );
}

export default Field
